import { render, staticRenderFns } from "./GChatSendButton.vue?vue&type=template&id=3ee35f42&"
import script from "./GChatSendButton.vue?vue&type=script&lang=ts&"
export * from "./GChatSendButton.vue?vue&type=script&lang=ts&"
import style0 from "./GChatSendButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports